<template>
  <div :class="classnames">
    <slot />
  </div>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'popup-content'

  export default {
    name: 'PopupContent',
    mixins: [ bem ],
    data: function () {
      return {}
    },
    created: function () {
      this.namespace = namespace
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/Popup/PopupContent.vue